module.exports = __webpack_public_path__ + "static/media/book7.4fd99760.jpg";